import React from 'react';
import PolicyNoticeBanner from './common/PolicyNoticeBanner';
import { POLICY_NOTICES, LBS_TERMS_V11_KEY } from '../config/policyNotices';

/**
 * 위치기반서비스 이용약관 (단일 소스)
 * - v1.1 전문: docs/위치기반서비스_이용약관_v1.1_게시본_2026-09-16.md §9-1 그대로(조문 순서·문장 변경 금지).
 *   공고 2026-09-16 · 시행 2026-10-17. 시행일 전까지는 v1.0이 적용되므로 v1.0 전문도 접기로 보존한다(§9-1 단서).
 * - 상단 고지 박스는 §9-2 문구 — 공고 기간과 무관하게 항상 노출(배너와 별개).
 * - 회사 정보·신고번호·관리책임자는 v1.1 제12조로 통합(종전 하단 "신고번호 | 상호 | 대표" 줄 삭제).
 * - 문구 변경 시 법적보안 확인.
 */
const NOTICE_BOX = `이 약관은 2026년 9월 16일에 공고되어 2026년 10월 17일부터 시행됩니다. 시행일 전까지는 종전 약관(v1.0)이 적용됩니다.
변경 요지: ①적용 화면 명시(치과 찾기·치과기공소 찾기·재제작 상담 신청) ②현재 위치를 약 100m 단위로 줄여 이용 ③검색은 회사 서버를 거쳐, 지도 표시는 브라우저에서 직접 주식회사 카카오에 전달(종전 "제3자 제공 없음" 문구 정정) ④법에서 정한 이용 기록을 6개월 보관(위치 좌표·접속 정보 제외) ⑤만 14세 이상 확인 ⑥철회 방법 ⑦이용 통계 항목 삭제 ⑧회사 정보·개인위치정보 관리책임자 표시`;

const TERMS_V11 = `위치기반서비스 이용약관 v1.1 (공고 2026년 9월 16일 · 시행 2026년 10월 17일)

제1조 (목적)
이 약관은 주식회사 덴탈클러스터(이하 "회사")가 제공하는 위치기반서비스(이하 "서비스")의 이용 조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.

제2조 (서비스의 내용)
① 회사가 제공하는 위치기반서비스는 회사 웹사이트에서 이용자의 현재 위치를 기준으로 가까운 치과의원 또는 치과기공소를 검색하거나 목록을 거리순으로 정렬하여 표시하고, 지도에 나타내는 서비스입니다. 구체적으로 치과 찾기, 치과기공소 찾기, 재제작 상담 신청 시의 치과기공소 목록 거리순 정렬 화면에서 제공됩니다.
② 이용자가 현재 위치 이용에 동의하지 않아도 지역명·상호 검색, 지도 이동, 지역 선택 등의 방법으로 서비스를 이용할 수 있습니다.

제3조 (위치정보의 이용 방법)
① 회사는 이용자가 사용하는 웹브라우저의 위치 기능(운영체제·브라우저가 제공하는 위치 확인 기능)을 통해 이용자의 위치(위도·경도)를 확인합니다.
② 회사는 확인한 위치를 소수점 넷째 자리 이하를 버려 약 100미터 단위로 줄인 뒤 이용합니다.
③ 회사는 이용자가 위치 이용 안내 화면에서 동의하고 브라우저의 위치 권한을 허용한 경우에만 현재 위치를 이용합니다.

제4조 (위치정보의 이용 목적)
회사는 위치정보를 다음 목적으로만 이용하며, 그 밖의 목적으로 이용하지 않습니다.
1. 현재 위치를 기준으로 한 주변 치과의원·치과기공소 검색 및 거리순 정렬
2. 검색 결과의 지도 표시

제5조 (위치정보의 보유 및 파기)
① 회사는 이용자의 위치를 저장하지 않으며, 검색 요청을 처리한 즉시 파기합니다. 회사의 서버 기록에도 위치를 남기지 않습니다.
② 회사는 「위치정보의 보호 및 이용 등에 관한 법률」 제16조제2항에 따라 위치정보를 이용한 사실을 자동으로 기록·보존합니다. 이 기록에는 이용 일시, 이용한 서비스, 위치정보를 전달한 자, 이용자가 확인한 위치 이용 안내의 판, 만 14세 이상 확인 여부만 포함되며, 위치 좌표와 접속 정보(IP 주소 등 이용자를 식별할 수 있는 정보)는 포함되지 않습니다. 이 기록은 6개월이 지나면 파기합니다.

제6조 (위치정보 처리의 위탁)
① 회사는 주변 검색과 지도 표시를 위하여 위치정보의 처리를 주식회사 카카오(카카오맵·로컬 검색)에 위탁합니다.
② 검색은 회사의 서버를 거쳐 주식회사 카카오에 전달되며, 지도 표시는 이용자의 브라우저에서 주식회사 카카오에 직접 요청하는 방식으로 이루어집니다. 이 과정에서 지도에 표시되는 화면 영역의 위치가 주식회사 카카오에 전달됩니다.
③ 회사는 위 목적 외에 이용자의 위치를 제3자에게 제공하지 않습니다.

제7조 (만 14세 미만 아동)
회사는 만 14세 미만 아동의 위치정보를 이용하지 않습니다. 이용자는 위치 이용 안내 화면에서 만 14세 이상임을 확인한 경우에만 현재 위치 기능을 이용할 수 있습니다.

제8조 (이용자의 권리와 행사 방법)
① 이용자는 현재 위치 이용에 동의하지 않거나, 동의한 뒤에도 언제든지 철회할 수 있습니다. 철회는 치과 찾기·치과기공소 찾기·재제작 상담 신청 화면의 [위치 이용 동의 철회]를 누르거나, 브라우저 설정에서 위치 권한을 끄는 방법으로 할 수 있습니다.
② 동의 여부는 이용자의 브라우저에만 저장되며 회사 서버로 전송되지 않습니다. 브라우저의 저장 정보를 삭제하면 동의 기록도 함께 사라집니다.
③ 이용자는 제5조제2항의 기록에 대하여 열람 또는 고지를 요구할 수 있습니다. 다만 이 기록에는 이용자를 식별할 수 있는 정보가 포함되어 있지 않아 특정 이용자의 기록만을 찾아 제공하기 어려울 수 있습니다.
④ 이용자는 위치정보의 이용·제공 일시중지를 요구할 수 있습니다.
⑤ 요구·민원 접수: 제12조의 개인위치정보 관리책임자 연락처

제9조 (손해배상)
회사는 「위치정보의 보호 및 이용 등에 관한 법률」 제26조에 따라 위치정보의 누출·변조·훼손 등으로 이용자에게 손해가 발생한 경우 배상 책임을 집니다.

제10조 (분쟁 해결)
위치정보에 관한 분쟁은 대한민국 법률에 따르며, 이용자는 방송통신위원회에 재정을 신청하거나 개인정보 분쟁조정위원회에 조정을 신청할 수 있습니다.

제11조 (약관의 변경)
회사는 이 약관을 변경하는 경우 시행일 30일 전부터 회사 웹사이트에 공고합니다.

제12조 (회사 정보 및 개인위치정보 관리책임자)
① 상호: 주식회사 덴탈클러스터 / 대표: 김승우 / 사업자등록번호: 318-81-11805 / 위치기반서비스사업 신고번호: 제1058호
② 주소: 경기도 김포시 태장로 846 한강센트럴자이2단지
③ 개인위치정보 관리책임자: 대표 김승우
④ 연락처: 전화 010-2972-3733 / 전자우편 dentcluster@gmail.com / 카카오톡 채널 pf.kakao.com/_xfsREX

부칙
이 약관은 2026년 10월 17일부터 시행하며, 같은 날 종전 위치기반서비스 이용약관 v1.0을 대체합니다.

변경 이력
· v1.0 (2026-04-15): 최초 제정
· 2026-08-06: 가입 시 위치 동의 필수 폐지(위치 기능 사용 시점 동의로 전환)
· v1.1 (2026-09-16 공고 · 2026-10-17 시행): 위치 이용 방식을 실제 동작에 맞게 정정 — 적용 화면 명시(제2조), 약 100m 단위 축약(제3조제2항), 검색은 회사 서버 경유·지도는 브라우저에서 직접 요청하는 카카오 처리 위탁 명시(제6조, 종전 "제3자 제공 없음" 문구 정정), 법정 이용 기록 조항 신설(제5조제2항, 좌표·접속 정보 제외·6개월), 만 14세 확인(제7조), 철회 방법 구체화(제8조), 종전 "시·군·구 단위 이용 통계 90일 보관" 삭제, 회사 정보·개인위치정보 관리책임자 조항 신설(제12조), 약관 변경 공고 조항 신설(제11조)`;

const TERMS_V10 = `위치기반서비스 이용약관 v1.0 (시행일: 2026년 4월 15일)

제1조 (목적)
이 약관은 주식회사 덴탈클러스터(이하 "회사")가 제공하는 위치기반서비스(이하 "서비스")의 이용 조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.

제2조 (서비스 내용)
회사가 제공하는 위치기반서비스는 다음과 같습니다.
① 사용자(치과의원, 환자)의 현재 위치를 기반으로 가까운 치과의원 및 치과기공소를 검색하여 거리순으로 정렬·표시하는 서비스
② 서비스 이용 통계 작성을 위한 비식별 위치 정보 수집 (시·군·구 단위)

제3조 (위치정보 수집)
① 회사는 서비스 제공을 위해 Google, Apple 등 웹브라우저 내장 HTML5 Geolocation API를 통해 사용자의 위치정보(GPS 좌표: 위도, 경도)를 수집합니다.
② 위치정보는 사용자가 웹브라우저의 위치 정보 제공에 명시적으로 동의한 경우에만 수집합니다.
③ 위치정보 수집을 거부하는 경우에도 서비스의 기본 기능은 이용 가능합니다 (거리순 정렬 제외).

제4조 (위치정보 이용)
수집된 위치정보는 다음 목적으로만 이용합니다.
① 가까운 치과의원·치과기공소 검색 결과의 거리순 정렬
② 서비스 이용 통계 (비식별 처리, 시·군·구 단위만 저장)
③ 수집 목적 외의 이용을 금지합니다.

제5조 (보유 및 파기)
① GPS 좌표(위도·경도)는 서버에 영구 저장하지 않으며, 브라우저 세션 종료 시 즉시 삭제합니다.
② 통계 데이터(시·군·구 단위, 비식별)는 90일간 보관 후 자동 파기합니다.

제6조 (제3자 제공)
수집된 위치정보는 제3자에게 제공하지 않습니다.

제7조 (이용자 권리)
① 이용자는 언제든 브라우저 설정에서 위치 권한을 철회할 수 있습니다.
② 위치정보의 열람·정정·삭제를 요청할 수 있으며, 회사는 지체 없이 처리합니다.
③ 민원 접수: 카카오톡 채널(pf.kakao.com/_xfsREX) / 010-2972-3733

제8조 (손해배상)
회사는 위치정보법 제26조에 따라 위치정보의 누출·변조·훼손 등으로 인해 이용자에게 손해가 발생한 경우 배상 책임을 집니다.

제9조 (분쟁 해결)
위치정보에 관한 분쟁은 대한민국 법률에 따르며, 위치정보 분쟁조정위원회를 활용할 수 있습니다.

변경 이력
· v1.0 (2026-04-15): 최초 제정
· 2026-08-06: 위치기반 동의 가입 필수 폐지 (거리순·지도 등 위치기반 기능 사용 시점에 브라우저 위치 권한으로 동의받는 방식으로 전환)`;

const textStyle = { fontSize: 13, color: '#374151', lineHeight: 1.9, whiteSpace: 'pre-wrap', margin: 0 };

function LocationTerms({ onClose }) {
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div style={{ background: '#fff', borderRadius: 16, maxWidth: 640, width: '100%', maxHeight: '85vh', overflow: 'auto', padding: 28 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <h2 style={{ fontSize: 18, fontWeight: 800, margin: 0 }}>위치기반서비스 이용약관</h2>
                    {onClose && (
                        <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#94a3b8' }}>&times;</button>
                    )}
                </div>

                {/* 공고 배너(시행일 다음 날 자동 내림) — 문안은 Firestore 값 우선, 없으면 정본 기본값 */}
                <PolicyNoticeBanner noticeKey={LBS_TERMS_V11_KEY} fallback={POLICY_NOTICES[LBS_TERMS_V11_KEY]} />

                {/* 상단 고지 박스 — 항상 노출 */}
                <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 14px', marginBottom: 18, fontSize: 12.5, color: '#334155', lineHeight: 1.8, whiteSpace: 'pre-wrap' }}>
                    {NOTICE_BOX}
                </div>

                <p style={textStyle}>{TERMS_V11}</p>

                <details style={{ marginTop: 22, borderTop: '1px solid #e5e7eb', paddingTop: 14 }}>
                    <summary style={{ fontSize: 13, color: '#475569', cursor: 'pointer', fontWeight: 700 }}>
                        v1.0 전문 보기 (2026년 10월 17일 시행 전까지 적용되는 종전 약관)
                    </summary>
                    <p style={{ ...textStyle, marginTop: 12, color: '#64748b' }}>{TERMS_V10}</p>
                </details>

                {onClose && (
                    <button onClick={onClose}
                        style={{ width: '100%', padding: 14, background: '#6366f1', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 20 }}>
                        확인
                    </button>
                )}
            </div>
        </div>
    );
}

export default LocationTerms;
